import { livePersonScript } from './scripts/live-person.embedded.script.js';
export const SCRIPTS = Object.assign({}, livePersonScript);
